var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgOrangeSpiral = function SvgOrangeSpiral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 145,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.33 69.706c-11.606 4.206-22.014 8.538-13.79 21.072 4.786 7.294 18.388 9.048 25.328 5.041 13.95-8.054 23.107-32.945 29.067-47.065 7.247-17.172 3.868-33.804-15.91-37.092-18.338-3.05-43.599 11.545-56.59 23.234C10.553 50.082 3.99 90.25 21.938 106.894c26.037 24.142 64.714 34.378 97.11 18.79 20.212-9.726 46.41-31.369 49.281-55.196",
    stroke: "#FFB341",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgOrangeSpiral;